{
  "name": "pharma-dash-web",
  "version": "1.3.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "start:prod": "ng serve --configuration production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "build:iza-css": "npm --prefix projects/iza i tailwindcss@4 --no-save --no-audit --no-fund --silent --legacy-peer-deps && npx @tailwindcss/cli@4 -i projects/iza/src/lib/styles/iza.tailwind.css -o projects/iza/src/lib/iza-bubble/iza.generated.css --minify && node scripts/wrap-iza-css.js"
  },
  "private": true,
  "engines": {
    "node": "^20.19.0 || ^22.12.0 || >=24.0.0"
  },
  "dependencies": {
    "@angular/animations": "^21.2.18",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.18",
    "@angular/compiler": "^21.2.18",
    "@angular/core": "^21.2.18",
    "@angular/forms": "^21.2.18",
    "@angular/google-maps": "^21.2.14",
    "@angular/material": "^21.2.14",
    "@angular/platform-browser": "^21.2.18",
    "@angular/platform-browser-dynamic": "^21.2.18",
    "@angular/router": "^21.2.18",
    "@auth0/auth0-angular": "^2.11.0",
    "@ericblade/quagga2": "^1.12.1",
    "@preset-sdk/embedded": "^0.1.8",
    "@rudderstack/analytics-js": "^3.23.0",
    "@superset-ui/embedded-sdk": "^0.1.3",
    "angular-shepherd": "^21.0.5",
    "announcekit-angular": "^14.0.5",
    "apexcharts": "^5.3.6",
    "canvas-confetti": "^1.9.3",
    "flowbite": "^2.2.1",
    "highlight.js": "^11.11.1",
    "lottie-web": "^5.13.0",
    "marked": "^17.0.1",
    "ng-apexcharts": "^2.0.4",
    "ngx-apexcharts": "^0.10.0",
    "ngx-cookie-service": "^21.3.1",
    "ngx-lottie": "^21.2.0",
    "ngx-mask": "^21.1.0",
    "ngx-pagination": "^6.0.3",
    "rxjs": "^7.8.2",
    "tailwind-scrollbar": "^3.1.0",
    "tailwindcss-animated": "^1.0.1",
    "tslib": "^2.3.0",
    "uuid": "^11.0.5",
    "xlsx": "^0.18.5",
    "zod": "^4.2.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^21.2.19",
    "@angular/cli": "^21.2.19",
    "@angular/compiler-cli": "^21.2.18",
    "@tailwindcss/container-queries": "^0.1.1",
    "@tailwindcss/typography": "^0.5.10",
    "@types/canvas-confetti": "^1.9.0",
    "@types/jasmine": "~5.1.0",
    "autoprefixer": "^10.4.17",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "ng-packagr": "^21.2.6",
    "postcss": "^8.4.33",
    "tailwindcss": "^3.4.1",
    "typescript": "5.9.3"
  }
}
